module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"change-lang-btn":"English"},"en":{"change-lang-btn":"Français"}}')
  delete Component.options._Ctor
}
